export default __webpack_public_path__ + "media/plus/plus-transfer-overview-1d1adbc2.jpg";